import { render, staticRenderFns } from "./site-team.vue?vue&type=template&id=2030163e&"
import script from "./site-team.vue?vue&type=script&lang=js&"
export * from "./site-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "site-team.vue"
export default component.exports